import React, { useEffect, useState } from "react";
import { Table, Modal, Checkbox, Button, Tooltip, Icon } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import config from "appConfig";
import styles from "../ManageReportPage/manageReportPage.scss";
import { getChatReports, updateChatReport } from "./chatReport.ducks";
import { api, formatDate, notification } from "../../../services";
import { IndexPagination } from "../../../components/IndexPagination";
import PageTitle from "../PageTitle";
import { saveAs } from "file-saver";
import {
  blockUser,
  unblockUser,
  getBlockReasons,
  selectBlockReasons,
} from "../ManageUserPage/user.ducks";
import { ReasonPickerModal } from "../ReasonPickerModal";
import ChatReportFilterForm from "./ChatReportFilterForm";


const CHAT_REPORT_REASONS = {
  1: "Inbox prijava"
}


const ManageChatReportPage = props => {
  const { page, itemPerPage, total, filters, reports, blockReasons } = props;
  const [loading, setLoading] = useState(false);
  const [currentFilters, setCurrentFilters] = useState({}); // preserve current filters
  const [pendingBlock, setPendingBlock] = useState(null);
  const [blockModalLoading, setBlockModalLoading] = useState(false);

  const columns = [
    {
      title: "Chat ID",
      dataIndex: "chatId",
      key: "chatId"
    },
    {
      title: "Reporter",
      dataIndex: "reporter",
      key: "reporter",
      render: (value, record) => (
        <Link
          title={record.reporterEmail}
          target="_blank"
          className={styles.link}
          to={`/admin/user/profile/${record.reporterId}`}
        >
          {record.reporterEmail}
        </Link>
      )
    },
    {
      title: "Reported",
      dataIndex: "owner",
      key: "owner",
      render: (value, record) => (
        <Link
          title={record.reporteeEmail}
          target="_blank"
          className={styles.link}
          to={`/admin/user/profile/${record.reporteeId}`}
        >
          {record.reporteeEmail}
        </Link>
      )
    },
    {
      title: "Datum prijave",
      dataIndex: "reportedDate",
      key: "reportedDate",
      render: value => formatDate(value)
    },
    {
      title: "Razlog",
      dataIndex: "reason",
      key: "reason",
      render: value => CHAT_REPORT_REASONS[value]
    },
    {
      title: "Opis",
      dataIndex: "description",
      key: "description",
      render: value => (
        <a
          href="#"
          onClick={() =>
            Modal.info({
              title: "Opis",
              content: value,
              width: props.descriptionPopupWidth,
              className: styles.descriptionExpanded
            })
          }
          className={styles.description}
        >
          {value}
        </a>
      ),
      width: props.descriptionColumnWidth
    },
    {
      title: "Kontaktiran",
      dataIndex: "contactedDate",
      key: "contactedDate",
      align: "center",
      width: 100,
      render: (value, record) => (
        <div className={`child-center ${styles.emailSentStyle}`}>
          <Checkbox
            onChange={e => handleContactedClick(record, e.target.checked)}
            checked={value ? true : false}
          />
          {value ? formatDate(value, config.fullTimeFormat) : null}
        </div>
      )
    },
    {
      title: "Riješeno",
      dataIndex: "solvedDate",
      key: "solvedDate",
      align: "center",
      width: 100,
      render: (value, record) => (
        <div className={`child-center ${styles.solved}`}>
          <Checkbox
            onChange={e => handleSolvedClick(record, e.target.checked)}
            checked={value ? true : false}
          />
          {value ? formatDate(value, config.fullTimeFormat) : null}
        </div>
      )
    },
    {
      title: "Akcije",
      key: "block",
      align: "center",
      dataIndex: "id",
      fixed: "right",
      width: 55,
      render: (value, record) => (
        <React.Fragment>
          <div
            style={{
              display: "inline-block",
              marginTop: "5px"
            }}
          >
            <Tooltip placement="topLeft" title="Skini Chat Log">
              <Button
                onClick={() => getChatLog(record.chatId)}
              >
                <Icon type="download" />
              </Button>
            </Tooltip>
          </div>
          <div
            style={{
              display: "inline-block",
              marginTop: "5px"
            }}
          >
            <Tooltip placement="topLeft" title={record.isReporteeBlocked ? "Odblokiraj" : "Blokiraj"}>
              <Button
                type={record.isReporteeBlocked ? "default" : "primary"}
                onClick={() => handleBlockClick(record.isReporteeBlocked, record)}
              >
                {record.isReporteeBlocked ? (
                  <Icon type="unlock" className="manage-ad-icon" />
                ) : (
                  <Icon type="lock" className="manage-ad-icon" />
                )}
              </Button>
            </Tooltip>
          </div>
        </React.Fragment>
      ),
    },
  ];

  const getChatLog = async (chatId) => {
    try {
      const promotedViewsStatistics = await api.Chat.getChatLog(chatId);
      saveAs("data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
        + promotedViewsStatistics, `chat-log-${chatId}.xlsx`);
    } catch (e) {
      console.error(e);
    }
  }


  useEffect(() => {
    props.getChatReports(filters, page, itemPerPage);
    if (!blockReasons || !blockReasons.length) {
      props.getBlockReasons();
    }
  }, []);

  const onPageChange = page => {
    props.getChatReports(currentFilters, page, itemPerPage);
  };

  const handleSearch = filters => {
    setCurrentFilters(filters);
    props.getChatReports(filters, 1, itemPerPage);
  };


  const handleBlockClick = (value, record) => {
    const { unblockUser: handleUnblockUser } = props;

    if (record.isReporteeBlocked) {
      Modal.confirm({
        title: `Želite li odblokirati ${record.reporteeEmail}?`,
        centered: true,
        onOk() {
          handleUnblockUser(record.reporteeId, null, () => props.getChatReports(filters, page, itemPerPage));
        },
      });
      return;
    }

    setPendingBlock({ userId: record.reporteeId, email: record.reporteeEmail });
  };

  const handleBlockCancel = () => {
    if (blockModalLoading) return;
    setPendingBlock(null);
  };

  const handleBlockConfirm = (reasonId, note, basedOn) => {
    if (!pendingBlock) return;
    setBlockModalLoading(true);
    props.blockUser(pendingBlock.userId, reasonId, note, basedOn, null, (success) => {
      setBlockModalLoading(false);
      if (!success) {
        notification.showError("Blokiranje korisnika nije uspjelo");
        return;
      }
      setPendingBlock(null);
      props.getChatReports(filters, page, itemPerPage);
    });
  };


  const handleContactedClick = (record, value) => {
    const data = {
      contactedDate: value ? new Date().toISOString() : null,
      solvedDate: record.solvedDate
    };

    setLoading(true);
    props.updateChatReport(record.id, data, reports, () => {
      props.getChatReports(filters, page, itemPerPage).then(() => setLoading(false));
    });
  };

  const handleSolvedClick = (record, value) => {
    const data = {
      solvedDate: value ? new Date().toISOString() : null,
      contactedDate: record.contactedDate
    };

    setLoading(true);
    props.updateChatReport(record.id, data, reports, () => {
      props.getChatReports(filters, page, itemPerPage).then(() => setLoading(false));
    });
  };


  return (
    <React.Fragment>
      <PageTitle title={"Prijave"} />
      <ChatReportFilterForm
        value={filters}
        onSubmit={handleSearch}
        className=""
      />

      <Table
        dataSource={reports}
        // @ts-ignore
        columns={columns}
        pagination={false}
        bordered
        rowKey="id"
        className="admin-table"
        loading={loading}
      />
      {reports.length > 0 ? (
        <IndexPagination
          total={total}
          page={page}
          itemPerPage={itemPerPage}
          onPageChange={onPageChange}
        />
      ) : null}

      <ReasonPickerModal
        visible={!!pendingBlock}
        title={
          pendingBlock && pendingBlock.email
            ? `Blokiraj korisnika ${pendingBlock.email}`
            : "Blokiraj korisnika"
        }
        reasons={blockReasons || []}
        submitText="Blokiraj"
        loading={blockModalLoading}
        onCancel={handleBlockCancel}
        onConfirm={handleBlockConfirm}
      />
    </React.Fragment>
  );
};

ManageChatReportPage.defaultProps = {
  descriptionPopupWidth: 800,
  descriptionColumnWidth: 200
};

export default connect(
  state => ({
    // @ts-ignore
    ...state.admin.report,
    blockReasons: selectBlockReasons(state),
  }),
  {
    getChatReports,
    updateChatReport,
    blockUser,
    unblockUser,
    getBlockReasons,
  }
)(ManageChatReportPage);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageChatReportPage/ManageChatReportPage.tsx